import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-page-three',
  templateUrl: './home-page-three.component.html',
  styleUrls: ['./home-page-three.component.scss']
})
export class HomePageThreeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
